import styled from '@emotion/styled'
import { Box, Input } from '@chakra-ui/core'
import colors from 'constants/colors'

interface TableContainerProps {
  columnWidths?: {
    [key: number]: string
  }
}

export const TableContainer = styled(Box)<TableContainerProps>`
  flex: 1;
  min-height: 0;
  overflow: hidden;
  position: relative;
  border: 1px solid ${colors.greyLight};
  border-radius: 5px;
  max-height: calc(100vh - 280px);
  overflow: auto;
`

export const Table = styled.table<TableContainerProps>`
  width: 100%;
  background: white;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  border-spacing: 0;
  border-collapse: separate;

  th,
  td {
    margin: 0;
    padding: 1rem;
    border-bottom: 1px solid;
    border-color: ${colors.greyLight};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    :last-of-type {
      border-right: 0;
    }
  }

  th {
    text-align: left;
    font-size: 0.875rem;
    font-weight: bold;
    color: ${colors.greyMain};
    text-transform: uppercase;
    background: white;
  }

  tr:last-of-type td {
    border-bottom: 0;
  }

  thead {
    background: ${colors.greyLight};
    position: sticky;
    top: 0;
    z-index: 1000;
  }

  thead,
  tbody tr {
    display: table;
    width: 100%;
    table-layout: fixed;
  }

  th:first-of-type,
  td:first-of-type {
    width: ${(props) => props.columnWidths?.[1] || '300px'};
  }

  th:nth-of-type(2),
  td:nth-of-type(2) {
    width: ${(props) => props.columnWidths?.[2] || '200px'};
  }

  th:nth-of-type(3),
  td:nth-of-type(3) {
    width: ${(props) => props.columnWidths?.[3] || '200px'};
  }

  th:nth-of-type(4),
  td:nth-of-type(4) {
    width: ${(props) => props.columnWidths?.[4] || '200px'};
  }

  th:nth-of-type(5),
  td:nth-of-type(5) {
    width: ${(props) => props.columnWidths?.[5] || '200px'};
  }

  th:last-of-type,
  td:last-of-type {
    text-align: center;
    width: ${(props) => {
      // Определяем номер последней колонки динамически
      const columnKeys = Object.keys(props.columnWidths || {}).map(Number)
      const maxColumn = Math.max(...columnKeys, 0)
      return props.columnWidths?.[maxColumn] || '150px'
    }};
  }
`

export const SearchInput = styled(Input)`
  max-width: 300px;
`
